import { render } from "./CloudUploadIcon.vue?vue&type=template&id=4d1a07fa"
import script from "./CloudUploadIcon.vue?vue&type=script&lang=js"
export * from "./CloudUploadIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__